import genericStore from "../generic_store";

export default {
    namespaced: genericStore.namespaced,
    state: {
        ...genericStore.state,
        endpoint: "countries",
        object: "country",
        header: [
            { text: "País", value: "name" },
            { text: "Ícono", value: "icon", sortable: false  },
            { text: "UTC", value: "utc_difference", sortable: true  },
            { text: "Actions", value: "actions", sortable: false }
        ]
    },
    mutations: {
        ...genericStore.mutations
    },
    actions: {
        ...genericStore.actions
    },
    getters: {
        ...genericStore.getters
    }
};
